// extracted by mini-css-extract-plugin
module.exports = {"label":"RadioButton_label__khKLU"};